import React, { useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { Task } from 'entities/task/model/types/tasks';
import { TModalMode } from '../../shared/model/types/modalMode.type';
import { changeExecutorId } from '../../widgets/Modals/model/slice/addModalSlice';
import { FieldErrors } from '../../entities/modal/model/types/modalFieldErrors';
import { changeEditModalExecutorId } from '../../widgets/Modals/model/slice/editModalSlice';
import { useTranslation } from 'react-i18next';

export const useExecutorsStaff = (
    modalMode: TModalMode,
    isDisabled: boolean,
    setFieldErrors: React.Dispatch<React.SetStateAction<FieldErrors>>
) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [optionFilter, setOptionFilter] = useState('');

    const pickedTaskUid = new URLSearchParams(window.location.search).get('task_id');

    const taskData: Task = useAppSelector((state) => state.tasksReducer.entities[pickedTaskUid]);
    const dispatch = useAppDispatch();

    const { employees } = useAppSelector((state) => state.tasksInformationReducer);
    const executorsData = employees.filter((exec) => {
        if (modalMode === 'addNewTask') {
            return employees;
        }
        return taskData?.involved?.executor_id === exec.id;
    });
    const [selectedStaff, setSelectedStaff] = useState(() => {
        // console.log('taskData', taskData);
        if (modalMode === 'addNewTask') return [];
        if (!taskData?.involved) return [];
        if (taskData?.involved.executor_id === null)
            return [
                { avatar_url: '', id: null, name: t('Features.ExecutorsStaff.NotSelected.text') },
            ];
        return executorsData.filter((exec) => exec.id === taskData?.involved?.executor_id);
        // return executorsData;
    });

    const toggleDropdown = () => {
        if (isDisabled) return;
        setIsOpen(!isOpen);
    };

    const filteredOptions = useMemo(() => {
        if (!optionFilter) return executorsData;

        const filtered = employees.filter((option) =>
            option.name.toLowerCase().includes(optionFilter.toLowerCase())
        );

        return filtered.length > 0
            ? filtered
            : [{ name: t('Features.ExecutorsStaff.NoResults.text'), avatar_url: '', id: null }];
    }, [executorsData, optionFilter]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOptionFilter(event.target.value);
    };

    const handleOptionClick = (value: any) => {
        setIsOpen(false);
        if (modalMode === 'addNewTask') {
            dispatch(changeExecutorId(value.id));
        }
        if (modalMode === 'editTask') {
            dispatch(changeEditModalExecutorId(value.id));
        }

        if (value.name === t('Features.ExecutorsStaff.NoResults.text')) return;
        setSelectedStaff([value]);

        setFieldErrors((prev) => ({ ...prev, executor: { isError: false, errorMessage: null } }));
    };
    return {
        filteredOptions,
        toggleDropdown,
        isOpen,
        handleInputChange,
        handleOptionClick,
        optionFilter,
        setIsOpen,
        selectedStaff,
        executorsData,
        employees,
    };
};
